module.exports = __webpack_public_path__ + "img/icon-05.a899f539.png";